import { render } from "./template.vue?vue&type=template&id=17df41d3&scoped=true"
const script = {}

import "./template.vue?vue&type=style&index=0&id=17df41d3&scoped=true&lang=css"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17df41d3"]])

export default __exports__